import { serviceConstants } from 'crisis-panic-button-view/src/utils/constant';
import { authorizedFetch } from 'abu-common-components';

export interface IOnCallEngineerResponse {
  userList: Array<string>;
  responseCode: string;
  responseMessage: string;
}

export interface ISingleIncident {
  incidentId: string;
  incidentUrl: string;
  created_at: string;
  assigneedEngineerName: Array<string>;
  incidentSummary: string;
  status: string;
}

export interface IIncidentListResponse {
  incidentList: Array<ISingleIncident>;
  responseCode: 200;
  responseMessage: 'SUCCESS';
}

const REQUEST_FAILED = 'Request failed';

export const getPagerdutyToken = async () => {
  const response = await authorizedFetch(process.env.REACT_APP_GET_PAGERDUTY_TOKEN_API as string, {
    method: 'POST',
    tokenKey: serviceConstants.OKTA_TOKEN_KEY
  });
  if (!response.ok) {
    throw new Error(response.error || REQUEST_FAILED);
  }
  return response.data;
};

export const postPagerDutyOnGoingIncidentList = async (token: string): Promise<IIncidentListResponse> => {
  const response = await authorizedFetch(
    process.env.REACT_APP_POST_PAGERDUTY_ONGOING_INCIDENT_LIST_API as string,
    {
      method: 'POST',
      headers: {
        'x-pagerduty-token': token
      },
      tokenKey: serviceConstants.OKTA_TOKEN_KEY
    }
  );
  if (!response.ok) {
    throw new Error(response.error || REQUEST_FAILED);
  }
  return response.data as IIncidentListResponse;
};

export const postPagerDutyOnCallEngineer = async (token: string): Promise<IOnCallEngineerResponse> => {
  const response = await authorizedFetch(
    process.env.REACT_APP_POST_PAGERDUTY_ONCALL_ENGINEER_API as string,
    {
      method: 'POST',
      body: JSON.stringify({ size: '1' }),
      headers: {
        'x-pagerduty-token': token
      },
      tokenKey: serviceConstants.OKTA_TOKEN_KEY
    }
  );
  if (!response.ok) {
    throw new Error(response.error || REQUEST_FAILED);
  }
  return response.data as IOnCallEngineerResponse;
};

export interface ICreateIncidentResponse {
  responseCode: number;
  responseMessage: string;
}

export const postPagerDutyCreateIncident = async (token: string): Promise<ICreateIncidentResponse> => {
  const response = await authorizedFetch(
    process.env.REACT_APP_POST_PAGERDUTY_CREATE_INCIDENT_API as string,
    {
      method: 'POST',
      headers: {
        'x-pagerduty-token': token
      },
      tokenKey: serviceConstants.OKTA_TOKEN_KEY
    }
  );
  if (!response.ok) {
    throw new Error(response.error || REQUEST_FAILED);
  }
  return response.data as ICreateIncidentResponse;
};
